import React from 'react';
import { cn } from '../../utils';

export const FullscreenLayout = ({
  children,
  header,
  footer,
  className,
}: {
  children: React.ReactNode;
  header: React.ReactNode;
  footer: React.ReactNode;
  className?: string;
}) => (
  <div className="h-dvh flex flex-col justify-between">
    {header}
    <div className={cn('flex-1 bg-accent-foreground', className)}>
      {children}
    </div>
    {footer}
  </div>
);
